import { defineStore } from "pinia";
import Services from '@/services/martyrServices'
import { mapMartyr } from '@/helpers/mapFuncs'
import { assertPersonType } from '@/helpers/personTypeGuard'

export const useMartyrsStore = defineStore("martyrs", {

state:()=>({
    martyr: {},
    martyrs: [],
}),
getters : {
    getMartyr() {
        return mapMartyr(this.martyr)
    },
    getMartyrs() {
        return this.martyrs.map(mapMartyr)
    }
},
actions : {
    /** Start Sets */
    setMartyr(martyr) {
        this.martyr = martyr
    },
    setMartyrs(martyrs) {
        this.martyrs = martyrs
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setMartyr(response.data.data)
            return response
        })
    },
    getFamilyByPersonId(id) {
        return Services.getFamilyByPersonId(id)
        .then((response)=>{
            let data = response.data.data.sacrificer;
            data.members = response.data.data.member;
            this.setMartyr(data)
            return response
        })
    },
    getProfileDataByPersonId(id) {
        return Services.getProfileDataByPersonId(id)
        .then((response)=>{
            // let data = response.data.data.martyr;
            // data.members = response.data.data.familyMembers;
            // data.residenceData = response.data.data.residenceData;
            // data.educationData = response.data.data.educationData;
            // data.employmentRecord = response.data.data.employmentRecord;
            // data.previousEmployment = response.data.data.previousEmployment;
            // data.administrativeData = response.data.data.administrativeData;
            // data.deathCertificates = response.data.data.deathCertificates;
            // data.martyrData = response.data.data.martyrData;
            let data = { ...response.data.data.martyr , ...response.data.data, members: response.data.data.familyMembers };
            assertPersonType(data, 1)
            this.setMartyr(data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setMartyrs(response.data.data)
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.martyrs.push(response.data.data)
            return mapMartyr(response.data.data)
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.martyrs[this.martyrs.findIndex((x)=>x.id == id)] = response.data.data?.person
            return mapMartyr(response.data.data?.person)
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.martyrs = this.martyrs.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});